"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskExec = void 0;
const tinyqueue_1 = __importDefault(require("tinyqueue"));
class TaskExec {
    constructor() {
        this.tasks = new tinyqueue_1.default([], (a, b) => a.execTime - b.execTime);
    }
    exec(func, ttl) {
        this.tasks.push({ func, execTime: Date.now() + ttl });
        this.handleNext();
    }
    handleNext() {
        if (!this.tasks.length) {
            return;
        }
        const { execTime } = this.tasks.peek();
        this.execNext(Math.max(execTime - Date.now(), 0));
    }
    execNext(ttl) {
        clearTimeout(this.handler);
        this.handler = setTimeout(() => {
            const { func } = this.tasks.pop();
            func();
            this.handleNext();
        }, ttl);
    }
}
exports.TaskExec = TaskExec;
